// src/index.jsx
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import './assets/stylesheets/variables.css';
import './assets/stylesheets/global.css';
import './assets/stylesheets/queries/phonemedia.css'


const rootEl = document.getElementById("root");
const root = ReactDOM.createRoot(rootEl);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
